import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Link} from "react-router-dom";
import {Button} from "reactstrap";
import Edit from '@material-ui/icons/Edit'



export default class LogsFinancials extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets_Financials_Logs._name, API.RequestType.READ_ALL);
		super(props, model);
		if (this.props.parent)
		{
			model.grandparent = props.parent
			this.request = "GET"
		}

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns;
		if (this.props.parent) // Two sets of column headers to handle a collection with parent and without parent
		{
			columns = [
				{
					Header: "Date Changed",
					id: "date",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => {
						return obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : '-'
					}
				},
				{
					Header: "User",
					id: "user",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => (obj.user ? obj.users.name_first + " " + obj.users.name_last : 'Admin')
				},
				{
					Header: "Field",
					id: "field",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => (obj.field.replace("_", " "))
				},
				{
					Header: "Original",
					id: "value_original",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => {
						if (obj.field === "Payment_Type")
						{
							switch (obj.value_original)
							{
								case "1": return "Cash"

								case "2": return "Check"

								case "3": return "Credit Card"

								case "4": return "Invoice"
							}
						}
						else if (obj.field === "Approved")
						{
							switch (obj.value_original)
							{
								case "0": return "False"

								case "1": return "True"
							}
						}
						else
						{
							return obj.value_original ? obj.value_original : "Blank"
						}
					}
				},
				{
					Header: "New",
					id: "value_new",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => {
						if (obj.field === "Payment_Type")
						{
							switch (obj.value_new)
							{
								case "1": return "Cash"

								case "2": return "Check"

								case "3": return "Credit Card"

								case "4": return "Invoice"
							}
						}
						else if (obj.field === "Approved")
						{
							switch (obj.value_new)
							{
								case "0": return "False"

								case "1": return "True"
							}
						}

						else
						{
							return obj.value_new ? obj.value_new : "Blank"
						}
					}
				},
				{
					Header: "Note",
					id: "note",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => (obj.note)
				},
			];

		}
		else
		{
			columns = [
				{
					Header: "Ticket Number",
					id: "ticket_number",
					accessor: obj => (obj.ticket),
					Cell: (props) => {
						let {original} = props;
						let {ticket} = original;
						return (
							<span>
								<Link to={`/tickets/${ticket}`}>
									{ticket}
								</Link>
							</span>
						);
					}
				},
				{
					Header: "Date Changed",
					id: "date",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => {
						return obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : '-'
					}
				},
				{
					Header: "User",
					id: "user",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => (obj.user ? obj.users.name_first + " " + obj.users.name_last : 'Admin')
				},
				{
					Header: "Field",
					id: "field",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => (obj.field.replace("_", " "))
				},
				{
					Header: "Original",
					id: "value_original",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => {
						if (obj.field === "Payment_Type")
						{
							switch (obj.value_original)
							{
								case "1": return "Cash"

								case "2": return "Check"

								case "3": return "Credit Card"

								case "4": return "Invoice"
							}
						}
						else if (obj.field === "Approved")
						{
							switch (obj.value_original)
							{
								case "0": return "False"

								case "1": return "True"
							}
						}
						else
						{
							return obj.value_original ? obj.value_original : "Blank"
						}
					}
				},
				{
					Header: "New",
					id: "value_new",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => {
						if (obj.field === "Payment_Type")
						{
							switch (obj.value_new)
							{
								case "1": return "Cash"

								case "2": return "Check"

								case "3": return "Credit Card"

								case "4": return "Invoice"
							}
						}
						else if (obj.field === "Approved")
						{
							switch (obj.value_new)
							{
								case "0": return "False"

								case "1": return "True"
							}
						}

						else
						{
							return obj.value_new ? obj.value_new : "Blank"
						}
					}
				},
				{
					Header: "Note",
					id: "note",
					/** @param {Tickets_Financials_Logs_Object} obj */
					accessor: obj => (obj.note)
				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: props => {
						return (
							<span>
								<Link to={`/financial/${props.original.ticket}`}>
									<Button color="green-meadow" size={"sm"} block={true}>
										<Edit fontSize={'small'}/></Button>
								</Link>
							</span>
						);
					}
				},
			];

		}

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Event Logs')}
							{this.renderHeaderRight("Event Logs", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
